const newQuery = (query, filter) => ({
    type: 'NEW_QUERY',
    query,
    filter,
});

export default newQuery;
